import React, { useEffect } from "react";
import StepTutorial from "./index-step";
import CarteraStep1 from '../../Resources/Images/Tutoriales/Cartera/Cartera-1.jpg';
import CarteraStep2 from '../../Resources/Images/Tutoriales/Cartera/Cartera-2.jpg';
import IconIndent from '../../Resources/Images/Tutoriales/Cartera/indent.jpg';
import IconDownload from '../../Resources/Images/Tutoriales/Cartera/download.jpg';

function getSteps() {
    return ['Paso 1', 'Paso 2'];
}

function getStepContent(stepIndex) {
    switch (stepIndex) {
        case 0:
            return <StepTutorial image={CarteraStep1} text={[
                'Seleccionar los filtros correspondientes antes de realizar la búsqueda',
                'Presione el botón Buscar'
            ]} />;
        case 1:
            return <StepTutorial image={CarteraStep2}
                text={[
                    <span key="s1">Al hacer click en <img src={IconIndent} alt="Abrir" /> podrás abrir la póliza y navegarla en sus distintas secciones</span>,
                    <span key="s2">Al hacer click en <img src={IconDownload} alt="Descargar" /> podrás descargar la póliza / certificado de cobertura</span>,
                    'Al hacer click en el botón “Descargar” podrás exportar tu listado de pólizas a Excel'
                ]} />;
        default:
            return '';
    }
}

export function Cartera({ activeStep, setSteps }) {
    const steps = getSteps();

    useEffect(() => {
        setSteps(steps);
    }, [setSteps, steps]);

    return (
        <>
            <h2>Cartera</h2>

            <div className="d-flex justify-content-center mb-4">
                {steps.map((label, index) => (
                    <div
                        key={label}
                        className={`text-center mx-2 px-3 py-2 rounded ${index === activeStep ? 'bg-primary text-white' : 'bg-light text-secondary'}`}
                        style={{ minWidth: 80 }}
                    >
                        <div className="fw-bold">{label}</div>
                        <div className="small">Paso {index + 1}</div>
                    </div>
                ))}
            </div>

            <div>
                {getStepContent(activeStep)}
            </div>
        </>
    );
}
